import { CSS } from '@grupoboticario/flora-react'

export const userInfosGridCss: CSS = {
  gridTemplateColumns: 'repeat(1, 1fr)',
  '@desktop': { gridTemplateColumns: 'repeat(3, 1fr)' }
}
